import { Status } from './Status.component';

export default Status;
